import { Apartment } from 'types/Apartments';
import { importAllFiles } from 'utils/importAllFiles';

export const importApartmentsFromEdifice = (): Apartment[] => {
  const fetched = importAllFiles(
    require.context('data/edifices', true, /edifice\.json$/),
  );

  // @ts-ignore
  const unique = [...new Set(fetched)];
  if (!unique.length) return [];

  const apartments = unique.reduce((all, edifice) => {
    if (!edifice.apartments) return all;

    all.push(...edifice.apartments);
    return all;
  }, []);
  if (!apartments) return [];

  return apartments;
};
